import React, { useCallback, useState, useEffect, useRef } from "react";
import { Button, Text, ButtonGroup } from "@shopify/polaris";
import EllipsisText from "react-ellipsis-text";

const DraggableListItemShopifyProduct = (props) => {
  return (
    <div style={{ width: "100%" }} className="listTable">
      <div style={{ minWidth: "20%" }}>
        <Text as="p" fontWeight="regular">
          {props.title ? (
            props.title
          ) : (
            <EllipsisText
              text={`${
                props.text &&
                props.text.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, "")
              }`}
              length={40}
            />
          )}
        </Text>
      </div>
      <div style={{ marginLeft: "auto" }}>
        <ButtonGroup>
          <Button plain onClick={() => props.handleEditItem(props.element)}>
            Edit
          </Button>
          <Button
            plain
            destructive
            onClick={() => props.handleDelete(props.id)}
          >
            Remove
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
};

export default DraggableListItemShopifyProduct;
